import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";
import leadership from "../assets/leadership.png";

export default function Staff() {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: false });
    AOS.refresh();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection bg-background" style={{ paddingBottom: "50px" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="main-section-title">Our Leadership</h6>
            <h6 className="text-dim pb-3">
              Our leadership structure is built on clear accountability, defined roles, and a unified strategic vision that drives operational excellence across all levels of the organization.
            </h6>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-12 text-center">
              <img src={leadership} style={{width:"100%"}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
